import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';

const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_RMS_HIRELIST_REQUEST = 'Foundation/hire/FETCH_RMS_HIRELIST_REQUEST';
const FETCH_RMS_HIRELIST_SUCCESS = 'Foundation/hire/FETCH_RMS_HIRELIST_SUCCESS';
const FETCH_RMS_HIRELIST_FAIL = 'Foundation/hire/FETCH_RMS_HIRELIST_FAIL';

const FETCH_RMS_HIREDATAS_REQUEST = 'Foundation/hire/FETCH_RMS_HIREDATAS_REQUEST';
const FETCH_RMS_HIREDATAS_SUCCESS = 'Foundation/hire/FETCH_RMS_HIREDATAS_SUCCESS';
const FETCH_RMS_HIREDATAS_FAIL = 'Foundation/hire/FETCH_RMS_HIREDATAS_FAIL';

export default function reducer(state = {
  keyword: '',
  singleDatas: [],
  listDatas: [],
  isSingleLoading: false,
  isListLoading: false,
}, action) {
  switch (action.type) {
    case FETCH_RMS_HIRELIST_REQUEST:
      return Object.assign({}, state, {
        isListLoading: true,
      });
    case FETCH_RMS_HIRELIST_SUCCESS:
      return Object.assign({}, state, {
        isListLoading: false,
        listDatas: action.response.data,
        page: action.response.meta,
      });
    case FETCH_RMS_HIRELIST_FAIL:
      return Object.assign({}, state, {
        isListLoading: true,
      });
    case FETCH_RMS_HIREDATAS_REQUEST:
      return Object.assign({}, state, {
        isSingleLoading: true,
      });
    case FETCH_RMS_HIREDATAS_SUCCESS:
      return Object.assign({}, state, {
        isSingleLoading: false,
        singleDatas: action.response.data,
        page: action.response.meta,
      });
    case FETCH_RMS_HIREDATAS_FAIL:
      return Object.assign({}, state, {
        isSingleLoading: true,
      });
    default:
      return state;
  }
}

export function fetchRMSHireList(keyword) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `RMSHireList/CV?keyword=${keyword}`,
      method: 'GET',
      types: [
        FETCH_RMS_HIRELIST_REQUEST,
        FETCH_RMS_HIRELIST_SUCCESS,
        FETCH_RMS_HIRELIST_FAIL,
      ],
    },
  };
}

export function fetchRMSHireDatas(id) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}RMSHireList/CV/${id}`,
      method: 'GET',
      types: [
        FETCH_RMS_HIREDATAS_REQUEST,
        FETCH_RMS_HIREDATAS_SUCCESS,
        FETCH_RMS_HIREDATAS_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Hire/screens/PersonalCreation/reducers/index.js
 **/